import { KaraokePresetTemplates } from '@src/types.ts/general';
import { AspectRatio } from '@src/types.ts/video';

export const getPresetTemplates = (
  defaultTemplate: Record<string, any>,
  aspectRatio: AspectRatio,
) => {
  return [
    {
      ...defaultTemplate,
      id: KaraokePresetTemplates.classic,
      title: 'Classic',
      fontFamily: 'Poppins',
      fontWeight: 700,
      backgroundColor: 'transparent',
      shadowColor: 'rgba(0,0,0,0.88)',
      shadowBlur: 2,
      shadowXOffset: 1,
      shadowYOffset: 2,
      strokeColor: 'transparent',
      strokeWidth: '0 vmin',
      letterSpacing: '0%',
      uppercase: false,
    },
    {
      ...defaultTemplate,
      id: KaraokePresetTemplates.typewriter,
      title: 'Typewriter',
      fontFamily: 'DM Mono',
      fontWeight: 500,
      backgroundColor: 'rgba(0,0,0,1)',
      strokeColor: 'transparent',
      strokeWidth: '0 vmin',
      letterSpacing: '0%',
      uppercase: false,
    },
    {
      ...defaultTemplate,
      id: KaraokePresetTemplates.edge,
      title: 'Edge',
      fontFamily: 'Special Gothic Expanded One',
      fontWeight: 400,
      backgroundColor: 'transparent',
      strokeColor: 'rgba(0,0,0,1)',
      strokeWidth: '1 vmin',
      letterSpacing: '50%',
      uppercase: false,
    },
    {
      ...defaultTemplate,
      id: KaraokePresetTemplates.blackAndWhite,
      title: 'Black & White',
      fontFamily: 'Inter',
      fontWeight: 600,
      backgroundColor: 'rgba(0,0,0,0.8)',
      strokeColor: 'transparent',
      strokeWidth: '0 vmin',
      letterSpacing: '0%',
      uppercase: false,
    },
  ];
};
